<style lang="scss">
  @import 'scss/main';
</style>
<template>
  <search-wrapper
    :asynchronous-results="true"
    :cludo-customer-id="2541"
    :cludo-engine-id="12714"
    :initially-load-results="true"
    :per-page="100"
    :search-url="searchUrl"
    ref="searchWrapper"
  >
    <section class="residences">

      <!-- Sidebar -->
      <aside class="residences__aside" role="complementary">

        <!-- Back button -->
        <div class="residences__back">
          <a href="../" class="btn btn--back icon-arrow-left">About our accommodation</a>
        </div>

        <!-- Filters -->
        <div class="residences__filters">
          <SearchFilters :isFiltering="isFiltering" :isLoading="loadingResults" :resultsCount="resultsCount" />
        </div>
      </aside>

      <!-- Main --> 
      <div class="residences__main">

        <!-- Meta -->
        <div :class="['residences__meta', loadingResults ? '': 'residences__meta--show']">
          
          <!-- Results Count -->
          <p class="residences__count"><strong>{{ resultsCount }} residence{{ resultsCount !== 1 ? 's': '' }}</strong> found</p>          
        
          <!-- Search Sorts -->
          <search-sorts label="Sort by:" :sorts.prop="[
            { text: 'Tenancy Cost (Low to High)', name: 'TotalTenancyCost_number', value: 'asc', selected: true },
            { text: 'Tenancy Cost (High to Low)', name: 'TotalTenancyCost_number', value: 'desc', selected: false },
            { text: 'Residence Name (A-Z)', name: 'Title', value: 'asc', selected: false },
            { text: 'Residence Name (Z-A)', name: 'Title', value: 'desc', selected: false },
          ]">
            <legend>Sort residences</legend>
          </search-sorts>
        </div>

        <!-- Search Results -->
        <search-results 
          :searchResultRenderer.prop="searchResultRenderer"
          :noResultsRenderer.prop="noResultsRenderer"
        ></search-results>
      </div>
    </section>
  </search-wrapper>
</template>
<script>
  import SearchResult from './components/SearchResult.vue'
  import SearchFilters from './components/SearchFilters.vue'
  import SearchNoResults from './components/SearchNoResults.vue'
  import { createApp } from 'vue'
  import { isEmpty } from 'lodash'; 

  export default {
    name: 'App',
    components: {
      SearchFilters
    },
    data() {
      return {
        loadingResults: true,
        postFilters: {},
        ranges: {},
        resultsCount: 0,
      }
    },
    computed: {

      /*
       * Returns the current window location pathname
       *
       * @returns {string}
       */
      searchUrl() {
        return window.location.pathname
      },

      /*
       * Returns whether any filters have been applied
       *
       * @returns {string}
       */
      isFiltering() {
        return !isEmpty(this.postFilters) || !isEmpty(this.ranges)
      }
    },
    methods: {

      /*
       * Overrides the default search result renderer by compiling a local Vue template
       *
       * @param {object} searchResult
       * @returns {string}
       */
      searchResultRenderer(searchResult) {
        return createApp(SearchResult, { searchResult }).mount(document.createElement('div')).$el.outerHTML
      },

      /*
       * Overrides the default no results renderer by compiling a local Vue template
       *
       * @returns {string}
       */
      noResultsRenderer() {
        return createApp(SearchNoResults, { isFiltering: this.isFiltering }).mount(document.createElement('div')).$el.outerHTML
      }
    },
    mounted() {

      // Listen for `searchResponse` events and update local component data
      this.$refs.searchWrapper.addEventListener('searchResponse', (event) => {
        this.resultsCount = event.detail.TotalDocument
      })

      // Listen for `loadingResults` events and update local component data
      this.$refs.searchWrapper.addEventListener('loadingResults', (event) => {
        this.loadingResults = event.detail
      })

      // Listen for `postFilters` events and update local component data
      this.$refs.searchWrapper.addEventListener('postFilters', (event) => {
        this.postFilters = event.detail
      })

      // Listen for `ranges` events and update local component data
      this.$refs.searchWrapper.addEventListener('ranges', (event) => {
        this.ranges = event.detail
      })
    }
  }
</script>